import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '@core/modules/auth/auth.guard';
import { errorPageRouteConfig } from '@pages/error-page/error-page.route-config';
import { pagesRouteConfig } from '@pages/pages-route-config.module';

const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: pagesRouteConfig
  },
  {
    path: '**',
    children: [errorPageRouteConfig]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
